import image from "../../img/fem.png";
import React from "react";
import { All, Button, LP, PP } from "./Style";
function Twotwotwo() {
  return (
    <All>
      <LP zrodlo={image} style={{ backgroundPosition: 0 }}></LP>
      <PP>
        <h1>Front End Mentor</h1>
        <p>Zobacz moje prace na serwisie Front End Mentor</p>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.frontendmentor.io/profile/Shotnik420"
        >
          <Button>Zobacz</Button>
        </a>
      </PP>
    </All>
  );
}

export default Twotwotwo;
